import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08637326")

_pushScopeId("data-v-08637326")
const _hoisted_1 = /*#__PURE__*/_createVNode("header", null, [
  /*#__PURE__*/_createVNode("h1", null, "Hi, I'm Dylan Widjaja")
], -1)
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "profile-image" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", null, "I'm a Software Engineer with strong skills in UI Engineering."),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" I primarily specialize in "),
    /*#__PURE__*/_createVNode("b", null, "React"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createVNode("b", null, "Typescript"),
    /*#__PURE__*/_createTextVNode(", and "),
    /*#__PURE__*/_createVNode("b", null, "Redux"),
    /*#__PURE__*/_createTextVNode(", but I am always open to learn new technology stacks. Even this current site is built in "),
    /*#__PURE__*/_createVNode("b", null, "Vue"),
    /*#__PURE__*/_createTextVNode("! ")
  ]),
  /*#__PURE__*/_createVNode("p", null, " Although I am primarily a UI engineer, I definitely do want to expand my skillset to something more than just UI ")
], -1)
const _hoisted_5 = { class: "right" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Feel free to look at my resume ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" here ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("printable version")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("), but here is a small blurb of my background: ")
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<p data-v-08637326> I received my B.S. in Kinesiology - Exercise Science at California State University, Long Beach, hoping to become a Physical Therapist. In my last semester, I made a last minute decision to not pursue it anymore. So I worked for about a year at a Medical Device company as a Regulatory Affairs Analyst. While working there, I had some friends convince me to consider going into software, so I started studying. </p><p data-v-08637326> After that job, I attended <b data-v-08637326>LearningFuze</b>, an accelerated coding bootcamp. Shortly finishing the bootcamp, I was offered a role at a Tax Automation Software company called <b data-v-08637326>SurePrep</b>. There is where I solidifed myself as a Software Engineer. </p><p data-v-08637326> At <b data-v-08637326>SurePrep</b>, I worked on the UI for <b data-v-08637326>TaxCaddy</b> - an interface that allows CPAs and Consumers to communicate and transfer documents. Essentially, a tool that helps CPAs and Consumers do taxes. Since the API was housed off-shore, I gained and immense knowledge of <b data-v-08637326>React</b> and <b data-v-08637326>Web</b> practices as well as <b data-v-08637326>Agile Methedologies</b> and cross-team workflows. </p><p data-v-08637326> After a little over two years at <b data-v-08637326>SurePrep</b>, I changed jobs and received an offer for <b data-v-08637326>Amazon</b> and <b data-v-08637326>Facebook</b>. Between the two, I decided to go to <b data-v-08637326>Facebook</b>. </p><p data-v-08637326> I spent about two years at Facebook (now Meta), working Ads Experiments, Facebook Groups, and an internal tool monitoring server capacity. </p><p data-v-08637326> After my time there, I decided to go from the biggest of big to the smallest of small, where I worked at a early stage startup called Presta. I was employee #6. </p><p data-v-08637326> My time there was a great experience and I felt that wearing many hats at Meta prepared me for the startup life. </p><p data-v-08637326> I decided after the startup to get back into a larger tech company, Docusign, where I work now. </p>", 8)
const _hoisted_19 = { class: "images" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Navigation = _resolveComponent("Navigation")

  return (_openBlock(), _createBlock(_component_Navigation, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode("main", null, [
        _createVNode("section", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              class: "image",
              src: _ctx.profileImg,
              alt: "Profile photo"
            }, null, 8, ["src"])
          ]),
          _hoisted_4
        ]),
        _createVNode("section", _hoisted_5, [
          _createVNode("div", null, [
            _createVNode("p", null, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                to: "/resume",
                target: "_blank",
                "aria-label": "link to resume",
                rel: "noopener noreferrer"
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _hoisted_8,
              _createVNode(_component_router_link, {
                to: "/printable-resume",
                target: "_blank",
                rel: "noopener noreferrer"
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            _hoisted_11
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("img", {
              src: _ctx.learningFuzeImg,
              alt: "learning-fuze image"
            }, null, 8, ["src"]),
            _createVNode("img", {
              src: _ctx.sureprepImg,
              alt: "sureprep image"
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
})